import React from 'react'
import styles from './JobCard.module.css'
import { JobCardProps } from '../../types'

const IMAGE = {
    mapIcon: {
        src: '/pages/google/JobInformation/map.svg',
        alt: 'マップピン'
    },
    yenIcon: {
        src: '/pages/google/JobInformation/yen.svg',
        alt: '¥アイコン'
    },
    bedIcon: {
        src: '/pages/google/JobInformation/bed.svg',
        alt: 'ベッドアイコン'
    }
}

export const JobCard: React.FC<JobCardProps> = ({ job, activeTab, onJobClick, config, dataClickLabel, area = 'nagoya' }) => {
    const resolvedImagePath = `https://foodsinfo.s3.ap-northeast-1.amazonaws.com/jobs/${area}/${job.image}`

    // eslint-disable-next-line complexity
    const handleJobCardClick = (e: React.MouseEvent) => {
        e.preventDefault()

        if (onJobClick) {
            let linkParams = { offerId: job.offerId.toString() }
            const paramMapping = config.parameterMapping

            switch (activeTab) {
                case 'area': {
                    let areaKey = job.prefecture
                    if (job.prefecture === '愛知県' && typeof job.location === 'string') {
                        areaKey = job.location.includes('名古屋市') ? '名古屋市' : '名古屋市外'
                    }
                    const areaParam = paramMapping.area[areaKey]
                    if (areaParam) {
                        linkParams = { ...areaParam, ...linkParams }
                    }
                    break
                }
                case 'genre': {
                    const genreParam = paramMapping.genre[job.type]
                    if (genreParam) {
                        linkParams = { ...genreParam, ...linkParams }
                    }
                    break
                }
                case 'position': {
                    const positionParam = paramMapping.position[job.position]
                    if (positionParam) {
                        linkParams = { ...positionParam, ...linkParams }
                    }
                    break
                }
            }

            onJobClick('JobCard_Click', linkParams)
        } else {
            const url = new URL('/signup', window.location.origin)
            url.searchParams.set('channel', 'googleadwords')
            url.searchParams.set('offerId', job.offerId.toString())
            window.location.href = url.toString()
        }
    }
    
    return (
        <article>
            <div className={styles.jobCard}>
                <a
                    href="#"
                    className={styles.cardLink}
                    onClick={handleJobCardClick}
                    data-click-label={dataClickLabel}
                >
                    <img 
                        src={resolvedImagePath} 
                        alt={`${job.title}のサムネイル画像`} 
                        className={styles.jobImage}
                        onError={(e) => {
                            const target = e.target as HTMLImageElement
                            target.src = '/pages/google/JobInformation/placeholder.jpg'
                        }}
                    />
                    <div className={styles.jobDetailText}>
                        <div className={styles.jobPositionTitle}>
                            <p>{job.type} | {job.position}</p>
                            <h3>{job.title}</h3>
                        </div>
                        <dl className={styles.jobConditions}>
                            <dd className={styles.locationInfo}>
                                <img 
                                    src={IMAGE.mapIcon.src} 
                                    alt={IMAGE.mapIcon.alt} 
                                    className={styles.mapIcon}

                                />
                                <div className={styles.locationText}>
                                    <p className={styles.prefecture}>{job.prefecture}</p>
                                    <p className={styles.location}>{job.location}</p>
                                </div>
                            </dd>
                            <span className={styles.separator}>|</span>
                            <dd className={styles.salaryInfo}>
                                <img src={IMAGE.yenIcon.src} alt={IMAGE.yenIcon.alt}/>
                                <p>月収<span>{job.minSalary}~{job.maxSalary}</span>万</p>
                            </dd>
                            <span className={styles.separator}>|</span>
                            <dd className={styles.durationInfo}>
                                <img src={IMAGE.bedIcon.src} alt={IMAGE.bedIcon.alt}/>
                                <p className={styles.duration}>{job.daysOff}</p>
                            </dd>
                        </dl>
                    </div>
                </a>
            </div>
        </article>
    )
}
